<template>
	<div class="w-full bg-gray-50">
		<div class="max-w-screen-2xl mx-auto px-4 sm:px-6 w-full md:px-8 mb-10 md:mb-0">
			<footer class="block lg:flex justify-between flex-col md:flex-row w-full md:items-center border-t-2 border-brand-500">
				<div class="flex flex-row justify-center md:justify-start w-full mt-2 gap-8">
					<a
						href="#"
						class="link"
						@click="confirmSetLanguage('en' as LangTypes)">
						English
					</a>
					<a
						href="#"
						class="link"
						@click="confirmSetLanguage('ja' as LangTypes)">
						日本語 (漢字)
					</a>
					<a
						href="#"
						class="link"
						@click="confirmSetLanguage('kana' as LangTypes)">
						日本語 (仮名)
					</a>
				</div>
				<div class="flex justify-center text-center md:text-left md:justify-end w-full mt-2 md:mr-4 text-xs flex-col md:flex-row sm:space-x-8 sm:py-4">
					<p>
						Email: music@crystalwedding.jp
					</p>
				</div>
			</footer>
		</div>	
		
		<tw-modal
			:title="t('nav.changeLanguageTitle')"
			modal-max-width="sm:max-w-xs md:max-w-3xl  bottom-80 h-fit sm:bottom-0"
			ref="confirmationModal">
			<ConfirmationCard 
				@cancel="toggleSaveSongModal"
				@save="() => {toggleSaveSongModal(); setLanguage()}"
				:description="t('nav.changeLanguage')" />
		</tw-modal>
	</div>
</template>

<script lang="ts">
	// name the component
	export default { name: "PageFooter" }
</script>

<script setup lang="ts">
	import ConfirmationCard from './ConfirmationCard.vue'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// store
	import { 
		localesStore
	} from '@/store/locales'
	// store
	import { 
		store as useJobStore
	} from '@/store/job'

	import { 
		LangTypes
	} from '@/types' // must be imported since file contains an export statement

	import EventBus from '@/events'

	import {
		ref
	} from 'vue'

	const store = localesStore()
	const jobStore = useJobStore()
	const {t, locale} = useI18n()

	const selectedLanguage = ref<LangTypes>('en' as LangTypes)

	function confirmSetLanguage(lang: LangTypes) {
		selectedLanguage.value = lang
		if(jobStore.job.loggedIn) toggleSaveSongModal()
		else setLanguage()
	}

	function setLanguage() {
		locale.value = selectedLanguage.value
		store.locales.selected = selectedLanguage.value

		// emit global event to reload data in new language
		EventBus.trigger('change-language', null)
	}

	const confirmationModal = ref<{open: boolean}>({open: false})
	function toggleSaveSongModal() {
		confirmationModal.value.open = !confirmationModal.value.open
	}

</script>